import { Button } from '@mui/material';
import { PlaidLinkOnSuccess, PlaidLinkOnSuccessMetadata, PlaidLinkOptions, usePlaidLink } from 'react-plaid-link';
import { useCreateAccessToken } from '../../../../logic';
import { useLocation, useParams } from 'react-router-dom';
import { useOptimisticUpdateNotificationAndOrderNotification } from '../../../../logic/optimisticUpdates';

export const PlaidLinkButtonComponent = ({linkToken}: {linkToken: string}) => {
  const { search } = useLocation()
  const { closingId, id } = useParams()
  const { optimisticUpdateNotificationAndOrderNotification } = useOptimisticUpdateNotificationAndOrderNotification()

  const createAccessToken = useCreateAccessToken(closingId ?? '', id ?? '', search)
  const onSuccess: PlaidLinkOnSuccess = (public_token: string, metadata: PlaidLinkOnSuccessMetadata) => {
    createAccessToken.mutate({publicToken: public_token, metadata: JSON.stringify(metadata)})
    optimisticUpdateNotificationAndOrderNotification({ orderKey: closingId ?? '', notificationId: id ?? '', search, patch: { IsComplete: true } })
  }
  const config: PlaidLinkOptions = {
    token: linkToken,
    onSuccess,
  }
  const { open, ready } = usePlaidLink(config);
  return (
    <Button
      variant="contained"
      color="primary"
      onClick={() => open()} disabled={!ready}
    >
      Connect and Verify Bank Account
    </Button>
  )
};
